import React, { FC, useState, useEffect } from "react";
import { Box, Modal as MuiModal, TextField, Typography, MenuItem, FormHelperText } from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDButton from "mdComponents/MDButton";
import MDInput from "mdComponents/MDInput";
import { CorporateAccount } from "../models/corporateAccountModel";
import { states } from "../constants";
import { useUser } from "context/UserContext";
import { User } from '../models/userModel';

interface EditProfileModalProps {
  visible: boolean;
  onSave: (updated: User) => void;
  onCancel: () => void;
}

const EditProfileModal: FC<EditProfileModalProps> = ({
  visible,
  onSave,
  onCancel,
}) => {
  const { user, setUser } = useUser();
  const [form, setForm] = useState(user);
  const [errors, setErrors] = useState<{ state?: string }>({});

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    onSave(form);
  };

  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: "absolute" as const,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 500,
          maxWidth: "90%",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h5" fontWeight="medium" mb={2}>
          Edit Profile
        </Typography>

        <MDBox display="flex" flexDirection="column" gap={2}>
          <TextField
            label="First Name"
            name="firstName"
            value={form.firstName}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Last Name"
            name="lastName"
            value={form.lastName}
            onChange={handleChange}
            fullWidth
          />
          <TextField
            label="Phone Number"
            name="phoneNumber"
            value={form.phone}
            onChange={handleChange}
            fullWidth
          />
        </MDBox>

        {/* Action Buttons */}
        <MDBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
          <MDButton variant="outlined" color="secondary" onClick={onCancel}>
            Cancel
          </MDButton>
          <MDButton color="info" onClick={handleSave}>
            Save
          </MDButton>
        </MDBox>
      </Box>
    </MuiModal>
  );
};

export default EditProfileModal;
